// Generated from ESF schema: SparkLiveness
// Do not edit manually!
/** Payload encryption method */
export var EncryptionType;
(function (EncryptionType) {
    EncryptionType["None"] = "none";
    EncryptionType["Symmetric"] = "symmetric";
    EncryptionType["MlKem"] = "ml_kem";
})(EncryptionType || (EncryptionType = {}));
//# sourceMappingURL=spark-liveness.js.map